export const getLastPathSegment = () => {
    const pathSegments = location.pathname.split('/');
    return pathSegments.at(-1) || '';
};

export const replaceLocation = (conditionFunction: (lastSegment: string) => boolean, newPath: string) => {
    const lastPathSegment = getLastPathSegment();
    if(conditionFunction(lastPathSegment)) {
        location.replace(newPath);
    }
    return lastPathSegment;
};
